<template>
  <div class="global-footer" id="global-footer">
    <div class="container">
      <div class="global-footer-hd" v-if="false">
        <a v-for="(item, index) in list"
           :key="index"
           :href="item.url"
           class="global-footer-link">
          {{ item.name }}
        </a>
      </div>

      <div class="global-footer-copyright">
        &copy; 1998 - {{ new Date().getFullYear() }} Tencent All Right Reserved.
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'global-footer',

    data () {
      return {
        list: [
          {
            name: '接入协议',
            url: 'http://www.qq.com/',
          },
          {
            name: '接入指南',
            url: 'http://www.qq.com/',
          },
          {
            name: '建议反馈',
            url: 'http://www.qq.com/',
          },
          {
            name: '关于我们',
            url: 'http://www.qq.com/',
          },
        ],
      };
    },
  };
</script>

<style lang="less" src="./index.less"></style>
